'use client'

import { usePathname } from '@/i18n/routing'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

// FloatingCTA wird erst ab scrollY > 500 sichtbar. Deshalb laden wir den Chunk
// (framer-motion-Animationen, CalendlyEmbed, Icons) erst, wenn der Besucher
// tatsächlich scrollt, identisches Verhalten, aber kein ungenutztes JS beim
// initialen Laden (v. a. mobil).
const FloatingCTA = dynamic(() => import('./FloatingCTA'), { ssr: false })

/**
 * Seiten, die den Kalender selbst inline zeigen. Dort waere die schwebende
 * Beratung ein zweiter Weg zum selben Kalender, der mobil zudem ueber dem
 * eingebetteten Widget liegt. Interne Pfad-Keys, gelten fuer beide Sprachen
 * (/kostenlose-beratung und /en/free-consultation).
 */
const PAGES_WITH_INLINE_CALENDAR = ['/kostenlose-beratung']

export default function FloatingCTALazy() {
  const pathname = usePathname()
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    if (window.scrollY > 0) {
      setShouldLoad(true)
      return
    }
    const onScroll = () => setShouldLoad(true)
    window.addEventListener('scroll', onScroll, { once: true, passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  if (PAGES_WITH_INLINE_CALENDAR.includes(pathname)) return null

  return shouldLoad ? <FloatingCTA /> : null
}
